(() => {
  'use strict';
  const root = document.querySelector('.rl-page');
  if (!root || root.dataset.rootlightReady) return;
  root.dataset.rootlightReady = 'true';
  const dialog = root.querySelector('[data-rl-dialog]');
  const player = dialog?.querySelector('video');
  let trigger;
  root.querySelectorAll('[data-rl-video]').forEach(button => button.addEventListener('click', () => {
    if (!dialog || !player) return;
    trigger = button;
    player.src = button.dataset.rlVideo;
    player.poster = button.querySelector('img')?.src || '';
    dialog.setAttribute('aria-label', button.dataset.rlTitle);
    dialog.showModal();
    player.play().catch(() => {});
  }));
  dialog?.querySelector('[data-rl-close]')?.addEventListener('click', () => dialog.close());
  dialog?.addEventListener('close', () => {
    player.pause();
    player.removeAttribute('src');
    player.load();
    trigger?.focus({preventScroll:true});
  });
  dialog?.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  const copy = {
    thinning: ['When hair feels less dense.', 'Take a baseline photo of the area that concerns you. Similar lighting and the same angle make comparisons more useful.', 200, 110, 28, 37],
    loss: ['Start by understanding the cause.', 'Hair loss has different causes. A qualified clinician can help identify yours and explain which treatment options may fit.', 200, 114, 57, 46],
    temples: ['Notice changes at the temples.', 'Photograph each side with your hair positioned the same way. Discuss gradual changes with a qualified clinician before choosing a routine.', 139, 109, 24, 31],
    spots: ['A patch deserves a closer look.', 'Sudden, patchy or unexplained hair loss needs medical assessment. Establish the cause before starting a light-based routine.', 224, 101, 24, 23],
    hairline: ['Keep your comparison consistent.', 'Use a straight-on photo and both side angles to track your hairline. Keep the lighting and distance consistent each time.', 200, 79, 54, 18],
    part: ['Make your part easy to compare.', 'Part your hair in the same place for each photo. A widening part can have several causes; a clinician can help assess it.', 200, 111, 15, 45]
  };
  const tabs = [...root.querySelectorAll('[data-rl-tab]')];
  const panel = root.querySelector('#rl-concern-panel');
  function select(tab) {
    const item = copy[tab.dataset.rlTab];
    tabs.forEach(button => {
      const active = button === tab;
      button.setAttribute('aria-selected', String(active));
      button.tabIndex = active ? 0 : -1;
    });
    panel.setAttribute('aria-labelledby', tab.id);
    panel.querySelector('[data-rl-concern-title]').textContent = item[0];
    panel.querySelector('[data-rl-concern-copy]').textContent = item[1];
    const highlight = panel.querySelector('[data-rl-highlight]');
    ['cx', 'cy', 'rx', 'ry'].forEach((attribute, index) => highlight.setAttribute(attribute, item[index + 2]));
  }
  tabs.forEach((tab,index) => {
    tab.addEventListener('click', () => select(tab));
    tab.addEventListener('keydown', event => {
      const next = {ArrowRight:(index + 1) % tabs.length, ArrowLeft:(index - 1 + tabs.length) % tabs.length, Home:0, End:tabs.length - 1}[event.key];
      if (next === undefined) return;
      event.preventDefault();
      tabs[next].focus(); select(tabs[next]);
    });
  });
})();
